// Reuse the existing footer content: disclosures on phones, open columns on desktop.
export default function mobileFooter() {
    const footer = document.querySelector('.lds-footer-vnext');
    const content = footer?.querySelector('.lds-footer-vnext__content');
    if (!content) return;
    const stacks = content.querySelectorAll(':scope > .lds-footer-vnext__stack');
    const organisation = stacks[0];
    const contact = stacks[1];
    const links = content.querySelector('.lds-footer-vnext__links');
    if (!organisation || !contact || !links) return;

    const wrap = (node, label) => {
        const details = document.createElement('details');
        details.className = 'lds-mobile-footer-disclosure';
        const summary = document.createElement('summary');
        summary.textContent = label;
        node.before(details);
        details.append(summary, node);
        return details;
    };
    const organisationDetails = wrap(organisation, 'Organisation & office');
    const navigationDetails = Array.from(links.querySelectorAll('h3')).map(heading => {
        const group = heading.parentElement;
        const label = group.parentElement === links && !group.hasAttribute('data-footer-secondary')
            ? 'Quick links' : heading.textContent.trim();
        const details = wrap(group, label);
        details.classList.add('lds-mobile-footer-navigation');
        return details;
    });
    contact.classList.add('lds-mobile-footer-contact');
    const postal = Array.from(contact.querySelectorAll('.lds-footer-vnext__panel'))
        .find(panel => panel.querySelector('h3')?.textContent.trim() === 'Postal');
    const postalAnchor = document.createComment('Postal desktop position');
    postal?.before(postalAnchor);
    const media = window.matchMedia('(max-width: 600px)');
    const disclosures = [organisationDetails, ...navigationDetails];
    const mobileOpen = new Map();
    const update = () => {
        disclosures.forEach(details => {
            details.open = media.matches ? (mobileOpen.get(details) || false) : true;
        });
        if (postal) {
            if (media.matches) organisation.append(postal);
            else postalAnchor.after(postal);
        }
    };
    disclosures.forEach(details => details.addEventListener('toggle', () => {
        if (media.matches) mobileOpen.set(details, details.open);
    }));
    media.addEventListener('change', update);
    update();
}
